


export interface CreateStripeSession {
    //
    prodId: string;
    couponId?: string;
    //
    organizationId: string;
    appId: string;
    //
    cancelPath: string;
    successPath: string;
}